import { render, staticRenderFns } from "./CriminalRecordEntry.vue?vue&type=template&id=732fcbe0&"
import script from "./CriminalRecordEntry.vue?vue&type=script&lang=js&"
export * from "./CriminalRecordEntry.vue?vue&type=script&lang=js&"
import style0 from "./CriminalRecordEntry.vue?vue&type=style&index=0&id=732fcbe0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports